import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_INFO, COMPANY_INFO } from '../../utils/constants';
import { SEO_KEYWORDS } from '../../utils/seoKeywords';
import PageSEO from '../../components/SEO';
import './Blog.css';

const BlogHome: React.FC = () => {
  const blogPosts = [
    {
      id: 'pickup-truck-rental-guide-dubai',
      title: 'Complete Guide to Pickup Truck Rental Services in Dubai 2025',
      excerpt: 'Everything you need to know about renting pickup trucks in Dubai, from 1-ton to 10-ton capacity trucks with tail lift for home shifting, office moving, and delivery services.',
      image: '/pickup-rental-truck-dubai-blog.jpeg',
      date: 'January 9, 2025',
      readTime: '8 min read',
      category: 'Truck Rental Guide'
    },
    {
      id: 'best-movers-packers-dubai-2025',
      title: 'Best Movers and Packers in Dubai 2025: Professional Moving Services',
      excerpt: 'Discover the top-rated movers and packers in Dubai offering professional home shifting, office relocation, and delivery services with modern pickup trucks.',
      image: '/pickup-rental-truck-dubai-blog.jpeg',
      date: 'January 8, 2025',
      readTime: '6 min read',
      category: 'Moving Services'
    }
  ];

  return (
    <div className="blog-home">
      <PageSEO
        title="Pickup Truck Rental & Moving Blog Dubai | Tips & Guides"
        description="Expert guides on pickup truck rental and moving in Dubai. Truck sizes, pricing, home shifting and office moving advice. Pickup Rental Truck Dubai."
        keywords={SEO_KEYWORDS.blog}
      />
      {/* Hero Section */}
      <section className="blog-hero">
        <div className="container">
          <h1>Pickup Truck Rental & Moving Services Blog</h1>
          <p>Expert insights, tips, and guides for pickup truck rental and moving services in Dubai</p>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="blog-posts">
        <div className="container">
          <h2>Latest Articles</h2>
          <div className="posts-grid">
            {blogPosts.map((post) => (
              <article key={post.id} className="blog-card">
                <div className="blog-image">
                  <img src={post.image} alt={post.title} />
                  <div className="blog-category">{post.category}</div>
                </div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <span className="blog-date">{post.date}</span>
                    <span className="blog-read-time">{post.readTime}</span>
                  </div>
                  <h3>
                    <Link to={`/${post.id}`}>{post.title}</Link>
                  </h3>
                  <p>{post.excerpt}</p>
                  <Link to={`/${post.id}`} className="read-more">
                    Read More →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="blog-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Need Pickup Truck Rental Services?</h2>
            <p>Contact us now for reliable and professional pickup truck rental services in Dubai</p>
            <div className="cta-buttons">
              <a href={`tel:${CONTACT_INFO.phone}`} className="btn-primary">Call: {CONTACT_INFO.phone}</a>
              <a href={`mailto:${CONTACT_INFO.email}`} className="btn-secondary">Email Us</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogHome;
